'use client'
import React, { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { IPatient } from '@umahealth/entities'
import { saveUtmParams } from '@/context/saveUtmParams'
import GirlWithTablet from '@/components/Auth/presentation/components/assets/illustrations/GirlWithTablet'
import ButtonCustom from '@/shared/components/ButtonCustom'

function BackToRegister({reason, patient, searchParams} : {
	reason : 'register' | 'OSS',
	patient: IPatient,
	searchParams: {
		/** utm params para trackear en analytics */
		utm_source?: string,
		/** utm params para trackear en analytics */
		utm_medium?: string,
		/** utm params para trackear en analytics */
		utm_campaign?: string,
	}
}){
	const history = useRouter()
	const path = reason === 'register' ? '/register' : '/firstCoverage'

	useEffect(() => {
		saveUtmParams({ objSearchParams: searchParams })
	}, [])

	return (
		  <div className='h-full w-full flex flex-col align-center p-6 justify-between'>
            <div className='text-center flex flex-col gap-4 items-center'>
                <GirlWithTablet/>
                <h1 className='text-lg font-bold text-[#263238]'>Registro en curso</h1>
                <p>Comenzaste a registrarte con el mail <b>{patient?.email}</b></p>
				<p>¿Querés continuarlo?</p>
            </div>
			<ButtonCustom onClick={() => history.push(path)}>
				Continuar mi registro
			</ButtonCustom>
        </div>
	)
}

export default BackToRegister
